import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const Navigation = (props) => {
  const { location, rider, event } = props
  const { pathname } = location

  if (pathname.includes('/rider/')) {
    return (
      <div className="navigation">
        <Link to="/library" className="back-arrow"></Link>

        {
          rider && rider.isFetching !== true
          ? rider.title
          : <div className="ui-loading" />
        }
      </div>
    )
  } else
  if (pathname.includes('/event/')) {
    return (
      <div className="navigation">
        <Link to="/library" className="back-arrow"></Link>

        {
          event && event.isFetching !== true
          ? event.title
          : <div className="ui-loading" />
        }
      </div>
    )
  } else {
    return null
  }
}

Navigation.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  rider: PropTypes.object,
  event: PropTypes.object
}

Navigation.defaultProps = {
  match: {},
  location: {},
  history: {},
  rider: {},
  event: {}
}

export const mapStateToProps = (state) => {
  return {
    rider: state.rider,
    event: state.event
  }
}

export default withRouter(connect(mapStateToProps, undefined)(Navigation))



// WEBPACK FOOTER //
// ./src/containers/navigation.js